import http from './request'
import { codeKey, taurusAppName, version, helpCodeKey, appType } from '@/constants/index'
import { mmseoBusinessEventToFirebaseEventMap } from '@/constants/buried'
import { getReportPointData } from 'web-utils/report'
import { queryURLParams } from 'web-utils/url'
import { isInNativeApp, deviceInfo } from 'web-utils/device'
import { getShareFrom, getAppType } from '@/utils/index'

/**
 * 埋点
 * @param {} data
 * @returns
 */
export const reportPointApi = (data) => {
  return http({
    url: `${import.meta.env.VITE_BURIED_API_URL}/user/buriedPoint/report`,
    method: 'post',
    data
  })
}

// pwa通用埋点
export function reportPoint(eventId, params = {}) {
  const isNative = isInNativeApp()
  reportPointApi(
    getReportPointData(
      eventId,
      {
        platform: isNative ? 'taurus' : getAppType(),
        shareFrom: getShareFrom() || '',
        taurusAppName: isNative ? 'taurus' : taurusAppName,
        code: isNative ? deviceInfo()?.code : localStorage.getItem(codeKey),
        appVersion: isNative ? deviceInfo()?.appVersion : version,
        source: queryURLParams('source') || ''
      },
      params
    )
  )
  if (appType == 'mmseo' && window.firebaseAnalytics) {
    window.firebaseAnalytics.logEvent(mmseoBusinessEventToFirebaseEventMap[eventId], params)
  }
}
// 推金币埋点
export function reportPointCoin(eventId, params = {}) {
  reportPoint(eventId, { is_fission: localStorage.getItem(helpCodeKey) ? '1' : '0', ...params })
}
